import { format } from "date-fns";
//FB 4867 DK - Importing missing classes
//FB 8549
import { ErrorLog, Facility, FacilityRegion, Provider, State, SupportFile, InputFile, CreditCardPaymentModel, AppointmentType } from "../store";     //FB 4487 DK - importing ErrorLog class //FB 6039  //FB 7719
//FB 6036
import AccessToken, { VideoGrant } from "twilio/lib/jwt/AccessToken";
import globalsettings from "../../../config";
import React from "react";	//FB 4867
import moment from "moment-timezone"; //FB 7675

// update log
// FB 4371 DK   03/29/2021    Added page to handle API calls
// FB 4371 DK   04/20/2021    Added a new parameter to identify the appointments created by PE
// FB 4371 DK   04/20/2021    Added new param to send appointment type
// FB 4487 DK   06/07/2021    Implemented error logging for API calls
// FB 4499 DK   06/09/2021	  Fix for appointment creation failure
// FB 4498 BR   06/10/2021	  Review email for note creation
// FB 4556 DK   07/07/2021    Implement client side error handling on PE
// FB 4653 BR   08/23/2021    PE - Text message changed in review emails
// FB 4660 BR   08/30/2021    PE - Appointment confirmation url
// FB 4661 BR   08/30/2021    PE - ParkingLot confirmation url
// FB 4696 DK   09/16/2021    Fixed "insurance accepted locations are seen under out-of-network on location dropdown" issue
// FB 4769 MS   11/02/2021    Added Job title Info for Provider
// FB 4780 BR   11/02/2021    In PE, Getting Email/Cell for Existing Patients
// FB 4763 DK   10/21/2021    Added new function to get decoded url's
// FB 4810 MS   11/22/2021    Fixed multiple calls to API issue
// FB 4831 BR   11/26/2021    Appointment Confirmation - it refreshs every sec when the page is still open.
// FB 4774 DK   11/24/2021    Added new function to format phone numbers
// FB 4867 DK   12/27/2021    Added screens for Support files and Health forms upload
// FB 4941 DK   02/07/2022    Added method to get parkinglot enable/disable flag
// FB 4949 DK   02/11/2022    Added method to get insurance enable/disable flag
// FB 4959 MS   03/01/2022    Added condition to hide PI button for existing patients in landing page
// FB 4960 BR   07/03/2022    Logging all actions on PE
// FB 6036 MS   05/20/2022    Telehealth Changes
// FB 6039 DK   06/30/2022    QR code scan changes
// FB 6109 DK   08/24/2022    Consent form integration changes
// FB 6264 DK   11/22/2022    Migrate PE API,DB to EMR
// FB 6361 DK	01/03/2023    Employee Bio missing on ByDate workflow
// FB 6752 DK   05/16/2023    Manage communication preference on PE
// FB 6963 AS   06/11/2023    Handle upload errors properly
// FB 7675 DK   11/09/2023    Timezone handling for appointments
// FB 7801 SK   12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time
// FB 7802 SK   12/14/2023    PE - Supporting Office-Specific Custom Appointment Types
// FB 7917 DK   12/15/2023    Timezone handling with admin setting
// FB 7997 SK   12/28/2023    PE- When an inactive appointment is mentioned in the admin parameter we should show that in PE
// FB 7719 SK   02/14/2024    PE- option to add credit card on file while booking an appointment
// FB 8108 KI   02/15/2024    Scanning the virus using clamAV antivirus while uploading the pdf file in portal
// FB 8680 DK   05/21/2024    Practice phone related changes
// FB 8549 DK   10/21/2024    TeleHealth re-work
// FB 9735 DK 	12/05/2024    On PE Sites, In Office vs TeleHealh is the First Patient Choice. These Must be Restictions Here
// FB 10473 GA 	12/05/2024    Latest Git PE Issues: Not Getting appt confirmation mail and Getting something went wrong popup
// FB 10941 DK  09/05/2025    MHA - Appointments dont get confirmed
// FB 10950 DK  09/10/2025    MHA updated to latest Git (Error: When receiving a reminder link via text message, clicking the link navigates to a blank page)


//FB 6264
const EMRbaseURL = globalsettings.emrAPI;

//FB 4371 DK    Added to get providers list
//FB 4487 DK    Optimized the code to avoid multiple API calls - Start 
export async function GetProviders(insurance_id: number, apptType: any): Promise<Provider[]> {
  let url: string = "";
  let finalList: any;
  let filteredProviders, allProviders;
  const union = (arr1: any, arr2: any, key: any) => [
    ...arr1
      .concat(arr2) // concat the arrays
      .reduce(
        (m: any, o: any) => (m.has(o[key]) ? m : m.set(o[key], o)),
        new Map()
      ) // reduce to a map by value of key
      .values(),
  ];

  // FB 4371 DK - Added condition to check the appointment type and change the end point
  if (apptType === "telederm") {
    // FB-6264
    url = globalsettings.emrAPI + "api/Provider/TeleHealth/GetAllProviders";
  }
  else {
    // FB-6264
    url = globalsettings.emrAPI + "api/Provider/GetAllProviders";
  }

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  const response = await fetch(url);
  if (!response.ok) {
    // FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    allProviders = await response.json();

    if (insurance_id > 0) {
      allProviders = allProviders.map((key: any) => ({
        ...key,
        InsuranceAcceptance: "Out-of-Network",
      }));
      filteredProviders = await GetProvidersByInsurance(insurance_id);
      finalList = union(filteredProviders, allProviders, "EMPLOYEE_N");
    }
    else {
      finalList = allProviders;
    }
    return finalList.map((key: any) => {
      return {
        name: `${key.EMPLOYEE_FIRST_NAME} ${key.EMPLOYEE_LAST_NAME}`,
        id: key.EMPLOYEE_N,
        facility_n: key.FACILITY_N,
        InsuranceAcceptance: key.InsuranceAcceptance,
        bio: key.EMPLOYEE_BIO,
        job_title: key.EMPLOYEE_JOB_TITLE  //FB 4769
      } as Provider;
    });
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}
//FB 4487 DK    Optimized the code to avoid multiple API calls - End

//FB 4960 BR Start-Logging all actions on PE
export async function GetPatientN(apptId: any) {
  const configUrl = globalsettings.emrAPI;
  const targetUrl = configUrl + "api/GetPatient_N?id=" + apptId;  //FB-6264
  return fetch(targetUrl).then((response) => response.json());
}

const insertLogs = async () => {
  InsertPELogs(globalsettings.clientIp, "Click on Phone Number");
}

export async function InsertPELogs(ipaddress: string, action: string) {
  const url = globalsettings.emrAPI;

  //FB 6264
  const targetUrl =
    url +
    "api/AddPELogs?ipaddress=" +
    ipaddress + "&action=" + action;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };
  return fetch(targetUrl, config).then((response) => response.ok);
}
//FB 4960 BR End-Logging all actions on PE

//FB 7802 - Begin
export async function GetAppointmentTypeFromAdmin(adminSettting: string) {
  let url = globalsettings.emrAPI + `api/Provider/GetAppointment?appointmentType=` + adminSettting;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    //FB 8549
    let data = await response.json();
    return data.map((type: any) => {
      return type as AppointmentType;
    });
  }
}
//FB 7802 End

//FB 7997 - Begin
export async function ValidateAppointmentType(appointmentTypes: string) {
  let url = globalsettings.emrAPI + `api/Provider/ValidateAppointmentType?appointmentTypes=` + appointmentTypes;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}
//FB 7997 End


//FB 4487 DK - Added method to get list of providers accept the selected insurance
export async function GetProvidersByInsurance(insurance_id: number): Promise<Provider[]> {
  const url = globalsettings.emrAPI + "api/Provider/GetProvidersByInsurance/" + insurance_id; //FB-6264
  const response = await fetch(url);

  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let filteredProviders = await response.json();
    filteredProviders = filteredProviders.map((key: any) => ({
      ...key,
      InsuranceAcceptance: "",
    }));

    return filteredProviders as Provider[];
  }
}

//FB 4780 BR-Start In PE, Getting Email/Cell for Existing Patients
export async function UpdateEmailCellPhone(patientId: number, email: string, cellphone: string) {
  const url = globalsettings.emrAPI;

  //FB-6264
  const targetUrl =
    url +
    "api/Reminder/UpdatePatientContactInfo?patientId=" +
    patientId + "&email=" + email + "&cellphone=" + cellphone;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };
  return fetch(targetUrl, config).then((response) => response.ok);
}

export async function FetchEmailCellPhone(patientId: number) {
  const url = globalsettings.emrAPI;

  //FB 4867 - Changed the API path
  //FB-6264
  const targetUrl =
    url +
    "api/Reminder/GetPatientContactInfoByPatient_N?id=" +
    patientId;

  return fetch(targetUrl).then((response) => response.json());
}
//FB 4780 BR-End In PE, Getting Email/Cell for Existing Patients

//FB 4371 DK    Added to get facility list
export async function GetFacilities(insurance_id: number) {
  let url: string =
    globalsettings.emrAPI +
    `api/Provider/GetFacilitiesByInsurance/${insurance_id}`;  //FB-6264

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  const response = await fetch(url);
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    //FB 4696 DK - Added logic to sort the insurance accepted locations to top of the list
    let data = await response.json();
    data = data.sort((a: any, b: any) => b.IsInsuranceAccepted - a.IsInsuranceAccepted);

    return data.map((key: any) => {
      return {
        name: key.FACILITY_NAME,
        id: key.Id,
        address:
          key.FACILITY_ADDRESS +
          ", " +
          key.FACILITY_CITY +
          ", " +
          key.FACILITY_STATE,
        phone:
          key.SCHEDULING_PHONE != null
            ? key.SCHEDULING_PHONE.replace(/[^0-9]/g, "")
            : "",
        region: key.Facility_Region_N,
        InsuranceAcceptance: key.IsInsuranceAccepted ? "" : "Out-of-Network",
      } as Facility;
    });
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to get facilities available for a date
export async function GetLocationsByDate(
  date: string,
  insurance_id: number
): Promise<[]> {
  let url: string =
    globalsettings.emrAPI +
    `api/Provider/GetFacilitiesByDate/${date}/${insurance_id}`; //FB-6264
  const response = await fetch(url);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();

    return data.map((key: any) => {
      return {
        name: key.FACILITY_NAME,
        id: key.Id,
        address:
          key.FACILITY_ADDRESS +
          ", " +
          key.FACILITY_CITY +
          ", " +
          key.FACILITY_STATE,
        InsuranceAcceptance: key.IsInsuranceAccepted ? "" : "Out-of-Network",
        phone: key.SCHEDULING_PHONE   //FB-4867
      } as Facility;
    });
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}
//FB 4487 DK - Removed GetProviderFacilities method since it's no longer used

//FB 4371 DK    Added to get providers available at specific location on particular date
export async function GetFacilityProviders(
  date: string,
  facility: number,
  insurance_id: number,	//FB 7801
  appointment_type_n: number //FB 7801
): Promise<Provider[]> {
  let url =
    globalsettings.emrAPI +
    `api/Provider/GetSlotsByDate/${facility}/${date}/1/${insurance_id}/${appointment_type_n}`;  //FB-6264	//FB-7801

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  const response = await fetch(url);
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    data = data.reverse();

    return data.map((key: any) => {
      return {
        name: `${key.Employee_First_Name} ${key.Employee_Last_Name}`,
        id: key.Employee_N,
        InsuranceAcceptance: key.isInsuranceAccepted ? "" : "Out-of-Network",
        bio: key.Employee_Bio,	//FB 6361
        job_title: key.Employee_Job_Title //FB 4769
      } as Provider;
    });
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to get regions list
export async function GetFacilityRegions(): Promise<FacilityRegion[]> {
  let url: string = globalsettings.emrAPI + "api/Provider/GetFacilityRegions";  //FB-6264
  const response = await fetch(url);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();

    return data.map((key: any) => {
      return {
        id: key.Id,
        name: key.REGION_NAME,
        state: key.REGION_STATE,
      } as FacilityRegion;
    });
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to get insurance carriers list
export async function GetInsuranceCarriers(): Promise<[]> {
  let url: string =
    globalsettings.emrAPI + "api/Provider/GetInsuranceCarriers";  //FB-6264
  const response = await fetch(url);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();

    return data.map((key: any) => {
      return {
        id: key.Id,
        name: key.INSURANCE_CARRIER_NAME,
      };
    });
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to get plans for the selected insurance
export async function GetInsurancePlans(carrier_id: number): Promise<[]> {
  let url: string =
    globalsettings.emrAPI +
    `api/Provider/GetInsurancePlans/${carrier_id}`; //FB-6264
  const response = await fetch(url);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();

    return data.map((key: any) => {
      return {
        id: key.Id,
        name: key.INSURANCE_PLAN_NAME,
      };
    });
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to get available slots on particular date
export async function GetAvailableSlotsByDate(
  startDate: string,
  location: number,
  provider: number
): Promise<any> {
  let url =
    globalsettings.emrAPI +
    `api/Provider/GetSlotsForProviderByDate/${startDate}/${location}/${provider}`;  //FB-6264
  //alert("limited:" + url);
  const response = await fetch(url);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    const data = await response.json();
    return data;
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to get US states list
export async function GetStates(): Promise<State[]> {
  let url: string = globalsettings.emrAPI + "api/Provider/GetAllStates";  //FB-6264
  const response = await fetch(url);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    const data = await response.json();

    return data.map((key: any) => {
      return {
        name: key.CODE,
      };
    });
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to search patient
export async function SearchPatient(patientObj: any): Promise<any> {
  //FB-6264
  const PatientUrl =
    globalsettings.emrAPI +
    "api/Provider/GetPatient?firstName=" +
    patientObj.PATIENT_FIRST_NAME +
    "&lastName=" +
    patientObj.PATIENT_LAST_NAME +
    "&dob=" +
    patientObj.PATIENT_BIRTH_DAY +
    "&gender=" +
    patientObj.GENDER_N;

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  const response = await fetch(PatientUrl);
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}
//FB 4959 MS BEGIN
export async function GetPatientType(patientId: any): Promise<any> {
  const PatientUrl =
    globalsettings.emrAPI +
    "api/Provider/GetPatientType?patientId=" + patientId; //FB-6264

  const response = await fetch(PatientUrl);
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
}

export async function GetPatientTypeByApptID(apptId: number): Promise<any> {
  const PatientUrl =
    globalsettings.emrAPI +
    "api/Provider/GetPatientTypeByApptID?apptId=" + apptId; //FB-6264

  const response = await fetch(PatientUrl);
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.text();//FB 10220
  }
}
//FB 4959 MS END
//FB 4487 DK - Removed SearchExistingPatient method since it's no longer used

//FB 4371 DK    Added to get number of appointments booked by the patient
export async function AppointmentCount(
  appointment_date: any,
  FirstName: any,
  LastName: any,
  DOB: any,
  Gender: any
) {
  //FB-6264
  const targetUrl =
    globalsettings.emrAPI +
    "api/Provider/GetAppointmentCount?date=" +
    format(appointment_date, "MM-dd-yyyy") +
    "&patient_first_name=" +
    FirstName +
    "&patient_last_name=" +
    LastName +
    "&dob=" +
    DOB +
    "&gender=" +
    Gender;

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  const response = await fetch(targetUrl);
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to create patient
export async function createPatient(patientObj: any, appObj: any) {
  //FB-6264
  const targetUrl = globalsettings.emrAPI + "api/Provider/Schedule/Patient/AddPatient";

  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(patientObj),
  };
  const response = await fetch(targetUrl, config);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    //FB 4556 DK - Implement client side error handling on PE - Start
    let appt_n = 0;
    //FB 4556 DK - Implement client side error handling on PE - End
    //FB-6264
    let data = await response.json();		//FB 4499 DK - changed the type from constant to reuse the variable
    sessionStorage.setItem("patient_n", data);//FB 7719
    //FB-6264
    appObj.PATIENT_N = data;
    var date = new Date(appObj.APPOINTMENT_DATE);
    var x = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - x);
    appObj.APPOINTMENT_DATE = date;
    appObj.APPOINTMENT_CHECKIN_TIME = date;
    if (appObj.PATIENT_N != 0) {
      //FB 4556 DK - Implement client side error handling on PE - Start
      appt_n = await createAppointment(appObj);
      sessionStorage.setItem("prev_appN", appt_n.toString());//FB 7719
      //FB 4556 DK - Implement client side error handling on PE - End
    }
    //FB 4556 DK - Implement client side error handling on PE - Start
    return appt_n;
    //FB 4556 DK - Implement client side error handling on PE - End
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to create appointment
export async function createAppointment(appObj: any) {
  //FB-6264
  appObj.APPOINTMENT_TYPE_OF_WORK = appObj.APPOINTMENT_TYPE_NAME;
  //FB 7675

  appObj.UTC_Offset = moment.tz(new Date(appObj.APPOINTMENT_DATE), moment.tz.guess(true)).utcOffset().toString();
  const targetUrl = globalsettings.emrAPI + "api/Provider/Schedule/BookAppointment";
  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(appObj),
  };
  const response = await fetch(targetUrl, config);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    //FB 4556 DK - Implement client side error handling on PE - Start
    return 0;
    //FB 4556 DK - Implement client side error handling on PE - End
  }
  else {
    let data = await response.json();		//FB 4499 DK - changed the type from constant to reuse the variable
    //FB-6264
    //FB 7675
    sendReminder(data, appObj.APPOINTMENT_DATE);
    //FB 4556 DK - Implement client side error handling on PE - Start
    //FB-6264
    return data;
    //FB 4556 DK - Implement client side error handling on PE - End
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to remove slot from preregistration table after Appt. is booked
export async function removePreRegistration(id: number) {
  //FB-6264
  const targetUrl = globalsettings.emrAPI + `api/Provider/Schedule/Preregistration/RemoveSlot?id=${id}`;
  const config = {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(targetUrl, config);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    const data = await response.json();
    return data;	//FB 6264
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to get the message based on the rating
//FB 4653 BR    PE - Text message changed in review emails
export async function GetMessage(ratingValue: any, id: any) {
  let url: string =
    globalsettings.emrAPI +
    "api/Provider/GetFeedbackAcknowledgement?stars=" +
    ratingValue + "&id=" + id;	//FB 4867 DK - Added new parameter  //FB-6264

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  const response = await fetch(url);
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4661 BR - PE - ParkingLot confirmation url
export async function ConfirmParkinglot(apptId: any, licenseName: string) {
  //FB 4867
  var str = licenseName;
  const configUrl = (globalsettings as any).emrAPI; //FB 10941
  const targetUrl =
    configUrl +
    "api/Reminder/ParkingLotConfirmation?appointmentID=" +
    apptId;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };
  return await fetch(targetUrl, config).then((response) => response.json()); //FB 4810
}

//FB 4660 BR    PE - Appointment confirmation url
export async function ConfirmAppt(apptId: number, licenseName: any) {
  var str = licenseName;
  const url = (globalsettings as any).emrAPI; //FB 10941

  const targetUrl =
    url +
    "api/Reminder/ReminderConfirmation?appointmentID=" +
    apptId;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };

  //FB 4867 - Added error logging
  const response = await fetch(targetUrl, config);
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.text();//FB 10220
  }
}

//FB 4660 BR    PE - Appointment confirmation url
export async function LinkExpiry(apptId: any, licenseName: string) {
  //FB 4867
  var str = licenseName;
  const configUrl = (globalsettings as any).emrAPI; //FB 10941
  const targetUrl =
    configUrl +
    "api/parkinglot/linkexpiry?id=" +
    apptId;
  return await fetch(targetUrl).then((response) => response.text());  //FB 4810 //FB 10220
}

//FB 4660 BR    PE - Appointment confirmation url
export async function GetSchedulingPhone(apptId: any, licenseName: string) {
  const configUrl = (globalsettings as any).emrAPI; //FB 10941
  const targetUrl =
    configUrl +
    "api/parkinglot/fetchSchedulingPhone?id=" +
    apptId;

  return await fetch(targetUrl).then((response) => response.json());  //FB 4810
}

//FB 4653 BR - PE - Text message changed in review emails
export async function GetPatientName(apptId: any) {
  const configUrl = globalsettings.emrAPI;
  const targetUrl =
    configUrl +
    "api/parkinglot/fetchPatientName?id=" +
    apptId;
  return fetch(targetUrl).then((response) => response.json());
}

//FB 4867
export async function GetPracticeName() {
  const configUrl = globalsettings.emrAPI;
  //FB 6264
  const targetUrl =
    configUrl +
    "api/Provider/GetPracticeName"
  return fetch(targetUrl).then((response) => response.json());
}

//FB 4371 DK    Added to get review link
//FB 4498 BR    Review email for note creation
export async function GetLink(id: any, flag: any) {
  let url: string =
    globalsettings.emrAPI + "api/Provider/GetReviewLink?id=" + id + "&flag=" + flag;  //FB-6264

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  const response = await fetch(url);
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4498 BR    Review email for note creation
export async function updateReviews(reviewStars: number | null, reviewComments: string, sessionId: number) {
  //FB-6264
  const targetUrl =
    globalsettings.emrAPI +
    "api/Provider/AddReview?reviewStars=" +
    reviewStars +
    "&reviewComments=" +
    reviewComments +
    "&sessionId=" +
    sessionId;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };
  const response = await fetch(targetUrl, config);
}

//FB 4371 DK    Added to send reminder notifications
//FB 7675
export async function sendReminder(id: number, apptdate: Date) {
  //FB 4371 DK - Added a new parameter to identify the appointments created by PE
  const targetUrl =
    globalsettings.emrAPI +
    "api/Reminder/ImmediateReminderNotification?appointment_n=" +
    id +
    "&isPEAppt=" +
    true+
    "&employee_n="+0; //FB 10473

  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  const response = await fetch(targetUrl, config);
  if (!response.ok) {
    //FB 6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB 4371 DK    Added to get patient phone number
export async function PatientCellPhone(
  firstname: string,
  lastname: string,
  gender: any,
  dob: any
) {
  //FB-6264
  const cellphoneAPIUrl =
    globalsettings.emrAPI +
    "api/Provider/GetPatientPhoneNumber?first_name=" +
    firstname +
    "&last_name=" +
    lastname +
    "&gender_n=" +
    gender +
    "&dateOfBirth=" +
    dob;

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  const response = await fetch(cellphoneAPIUrl);
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

//FB-6264 - Removed unused code

//FB 4763 DK - Added new function to get decoded url's - Start
export async function GetdecodedURL(urlcode: string): Promise<string> {
  let url = globalsettings.emrAPI + `api/Provider/GetShortURL/${urlcode}`;  //FB-6264
  const response = await fetch(url);

  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.text();  //FB 10950
    return data;
  }
}
//FB 4763 DK - Added new function to get decoded url's - End

//FB 4774 DK - Added new function to format phone numbers - Start
//FB 4867 DK = Return formatted phone number as link
export function formatphone(phonenumber: any) {
  let practicePhone = sessionStorage.getItem("DefaultPhone"); //FB 8680
  let phonenumberLink = "";
  if (phonenumber != "" && phonenumber != null && phonenumber != undefined) {
    phonenumber = phonenumber.replace(/[^0-9]/g, "");
    phonenumberLink = "tel:+1" + phonenumber;
    phonenumber = "(" + phonenumber.slice(0, 3) + ") " + phonenumber.slice(3, 6) + "-" + phonenumber.slice(6, 10);
    //FB 8680
  } else if (practicePhone != "" && practicePhone != null && practicePhone != undefined) {
    phonenumber = practicePhone;
    phonenumber = phonenumber.replace(/[^0-9]/g, "");
    phonenumberLink = "tel:+1" + phonenumber;
    phonenumber = "(" + phonenumber.slice(0, 3) + ") " + phonenumber.slice(3, 6) + "-" + phonenumber.slice(6, 10);
  }
  else {
    phonenumber = "";
  }
  return (<a href={phonenumberLink} > {phonenumber}</a >);
}
//FB 4774 DK - Added new function to format phone numbers - End

//FB 4867 DK - Added new functions for File upload and Health forms - Start
export async function UploadDocuments(Documents: SupportFile[], appointment_n: number) {
  const TokenURL = globalsettings.emrAPI + "api/GetAuthenticationToken/" + appointment_n;
  const response = await fetch(TokenURL);
  const AuthenticationToken = await response.json();

  if (!response.ok || AuthenticationToken.length <= 0) {
    var JSAlert = require("js-alert");
    JSAlert.alert("Authentication failed. Please try again later.", null, JSAlert.Icons.Warning);
  }
  else {
    const targetUrl = globalsettings.emrAPI + "api/Convertbase64ToImage";

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("token", AuthenticationToken[0].Token);//FB 10220

    const response = await fetch(targetUrl, {
      mode: 'cors',
      method: 'POST',
      headers: headers,
      body: JSON.stringify(Documents),
    });

    if (!response.ok) {
      //FB 8108 start
      if (response.status === 400) {
        NotifyVirusDetected();
      } else {
        //FB-6264
        NotifyErrorOutage();
        return Promise.reject();
      }
    }
    //FB-8108 end
    else {
      return response.status;
    }
  }
}

//FB 6264

export async function GetDocumentCategories() {
  let url = globalsettings.emrAPI + "api/GetDocumentCategories/FileUpload";
  const response = await fetch(url).then((data) => data.json()).catch((error) => error);

  return response;
}

export async function GetLicenseName() {
  let url = globalsettings.emrAPI + `api/Provider/GetLicenseName`;  //FB-6264
  const response = await fetch(url);

  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}

export async function GetPatientContactInfo(appointment_n: number) {
  //FB-6264
  let url = globalsettings.emrAPI + `api/Reminder/GetPatientContactInfoByAppt_N?id=${appointment_n}`;
  const response = await fetch(url);

  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}

export async function SendOTP(appointment_n: number, isPEAppt: boolean, send_email: number, send_text: number) {
  let url = globalsettings.emrAPI + `api/PatientIntake/UpdateVerificationCode?appointment_n=${appointment_n}
&isPEAppt=${isPEAppt}&emailSelect=${send_email}&phoneSelect=${send_text}`;
  const response = await fetch(url);

  if (!response.ok) {
    //FB 6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.text();//FB 10220
    return data;
  }
}

export async function GetOTP(appointment_n: number, isPEAppt: boolean) {
  let url = globalsettings.emrAPI + `api/PatientIntake/GetVerificationCode?appointment_n=${appointment_n}&isPEAppt=${isPEAppt}`;
  const response = await fetch(url);

  if (!response.ok) {
    //FB 6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}

//FB-6264

//FB 6036 BEGIN
export async function getTwilioToken(identity: string, room: string) {

  const generateToken = (config: any) => {
    return new AccessToken(
      globalsettings.twilio.accountSid,
      globalsettings.twilio.apiKey,
      globalsettings.twilio.apiSecret
    );
  };

  const videoToken = (identity: any, room: any, config: any) => {
    let videoGrant;
    if (typeof room !== 'undefined') {
      videoGrant = new VideoGrant({ room });
    } else {
      videoGrant = new VideoGrant();
    }
    const token = generateToken(config);
    token.addGrant(videoGrant);
    token.identity = identity;
    return token;
  };

  const token = videoToken(identity, room, globalsettings);
  // return JSON.stringify({
  //   token: token.toJwt()
  // });
  if (identity == "patient")
    updateTelePatientDetails(1, parseInt(room));
  return token.toJwt();
}

export async function updateTelePatientDetails(isPatientJoined: number, appt_id: number) {
  //FB-6264
  const targetUrl =
    globalsettings.emrAPI +
    "api/Provider/TeleHealth/UpdatePatientCallStatus?isPatientJoined=" +
    isPatientJoined +
    "&appt_id=" +
    appt_id;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };
  const response = await fetch(targetUrl, config);
  return response;
}
//FB 6036 End

//FB 6039 Start
//QR code scan to import photos in EMR
export async function UploadImages(Documents: InputFile, token: string) {

  const targetUrl = globalsettings.emrAPI + "api/yii/saveimage";
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("token", token);
  headers.append("X-Requested-With", "ajax"); //FB 6963 this will tell API that this is AJAX so that it returns errors as JSON objects
  const response = await fetch(targetUrl, {
    mode: 'cors',
    method: 'POST',
    headers: headers,
    body: JSON.stringify(Documents),
  });

  if (!response.ok) {
    //FB 6963 throw instead of rejecting
    const result = await response.json();
    throw new Error(result.ExceptionMessage || result.Message);
  }
  else {
    return response.status;
  }
}
//FB 6039 End

//FB 6109 Start
export async function GetAppointmentType(appt_id: string) {
  //FB-6264
  let url = globalsettings.emrAPI + `api/Provider/GetAppointmentType?appt_id=` + appt_id;
  const response = await fetch(url);

  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}
//FB 7719 Begin
export async function GetSavedCards(patient_n: number) {
  let url = globalsettings.emrAPI + `api/getCardName?patient_n=` + patient_n;

  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  } else {
    const data = await response.json();
    return data;
  }
}
//FB 7719 End

export async function GetAdminSettingValue(setting: string) {
  //FB-6264
  let url = globalsettings.emrAPI + `api/Provider/GetAdminSettingValue?settingName=` + setting;
  const response = await fetch(url);

  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data[0];
  }
}
//FB 6109 End

//FB 6452
export async function UpdatePatientCommunicationPreference(patient_n: number, comm_pref: string) {
  let url = globalsettings.emrAPI + "api/Provider/Schedule/Patient/UpdateCommunicationPreference?patient_n=" + patient_n + "&comm_pref=" + encodeURIComponent(comm_pref);
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return "Updated!";
  }
}

//FB 7675
export function ConvertTimeZone(slotDate: string, slotTime: string, userTimeZone: string, type: string) {
  //FB 7917 - Start
  var convertedSlot = type == "datetime" ? slotDate + " " + slotTime : slotTime;

  if (sessionStorage.getItem("timeZoneFlag") == "true") {
    var formattedSlot = moment(new Date(slotDate + " " + slotTime)).format("YYYY-MM-DD HH:mm");
    var slotAsPerServer = moment.tz(formattedSlot, "America/Port-au-Prince");
    convertedSlot = type == "datetime" ? slotAsPerServer.tz(userTimeZone).format() : slotAsPerServer.tz(userTimeZone).format("hh:mm A");
  }
  //FB 7917 - End
  return convertedSlot;
}

//FB-6264
export async function NotifyErrorOutage() {
  var JSAlert = require("js-alert");
  JSAlert.alert("Something went wrong. Please try again later.", null, JSAlert.Icons.Warning);
}

//FB 8108
export async function NotifyVirusDetected() {
  var JSAlert = require("js-alert");
  JSAlert.alert("Virus detected - file cannot be uploaded", null, JSAlert.Icons.Warning);
}

//FB 7719 Begin
export async function GetPaymentToken(SID: string) {
  let obj = globalsettings.emrAPI;
  if (obj != null) {
    //let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = obj + "/api/cc/paymentToken?SID=" + SID;
    const result = await fetch(targetUrl);
    if (result.ok) {
      var data = await result.json();
      if (data != null) {
        return data.Session.PaymentToken;
      }
    } else {
      NotifyErrorOutage();
      return Promise.reject();
    }
  }
}

export async function SaveCard(cc: CreditCardPaymentModel) {
  let obj = globalsettings.emrAPI;
  if (obj != null) {
    //let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = obj + "/api/cc/saveCard";

    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      body: JSON.stringify(cc),
    };
    const response = await fetch(targetUrl, config);
    if (!response.ok) {
      NotifyErrorOutage();
      return Promise.reject();
    } else {
      return response;
    }
  }

}


export async function postIframedata() {

  let obj = globalsettings.emrAPI;
  if (obj != null) {
    const targetUrl = obj + "api/cc/paymentUrl";
    const config = {
      method: "POST",
    };
    const response = await fetch(targetUrl, config);
    if (!response.ok) {
      NotifyErrorOutage();
      return Promise.reject();
    } else {
      var iframedata = await response.json();
      return iframedata;
    }
  }
}
//FB 7719 End

//FB 8549
export async function GetAppointmentTypes(filter: string, patientType: string) {
  let url = globalsettings.emrAPI + `api/Provider/Schedule/GetAppointmentTypes?filter=` + filter + `&patientType=` + patientType;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data.map((key: any) => {
      return key as AppointmentType;
    });
  }
}

//FB 9735
export async function GetAllAppointmentTypes() {
  let url = globalsettings.emrAPI + `api/Provider/Schedule/GetAllAppointmentTypes`;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data.map((key: any) => {
      return key as AppointmentType;
    });
  }
}
